export enum ErrorCodesEnum {
  Code_404 = 404,
}
